import { deprecate } from "util";
export const deprecateConstructorEntries = deprecate(() => { }, "Constructor \"entries\" argument is not spec-compliant "
    + "and will be removed in next major release.");
